// src/pages/AudiencePage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import AudienceConfig from '../components/ui/AudienceConfig';

function AudiencePage() {
	const { surveyId } = useParams();

	return (
		<AudienceConfig surveyId={surveyId} />
	);
}

export default AudiencePage;